export default "__VITE_ASSET__3e676476__"